

const picture = {
  home : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455059/Isioma_project/work/home_jclknt.jpg',
  menu : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697637015/Isioma_project/work/menu_e3d5xf.png',
  arrowright : 'https://res.cloudinary.com/dneejvhch/image/upload/v1702412087/Campusbuy/arrows_acckc3.png',
  arrowleft : 'https://res.cloudinary.com/dneejvhch/image/upload/v1702412087/Campusbuy/arrowleft_rwv1h6.png',
  facebook : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455019/Isioma_project/work/facebook_egls0e.png',
  family : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455020/Isioma_project/work/family_g7hhxc.webp',
  logo : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697829060/Isioma_project/work/logo_y0zqrk.png',
  hotel : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455061/Isioma_project/work/hotel_rac8ha.jpg',
  hotel1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455062/Isioma_project/work/hotel1_rmsfc6.jpg',
  houseA1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455062/Isioma_project/work/houseA1_tqrhkp.jpg',
  cancel : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455019/Isioma_project/work/cancel_o0xflr.png',
  houseA : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455062/Isioma_project/work/houseA_qjxkri.webp',
  houseBA1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697472311/Isioma_project/work/houseBA1_zuqgox.jpg',
  houseBA2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455063/Isioma_project/work/houseBA2_l5vzgw.jpg',
  houseB2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455063/Isioma_project/work/houseB2_hqbcbg.jpg',
  houseB : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455063/Isioma_project/work/houseB_ionrzt.jpg',
  houseB1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455063/Isioma_project/work/houseB1_hbhxnq.jpg',
  houseBA : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455063/Isioma_project/work/houseBA_vlm1yz.jpg',
  houseBB : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455064/Isioma_project/work/houseBB_gisk8o.jpg',
  houseBC : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455064/Isioma_project/work/houseBC_i88lrr.jpg',
  houseBD : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455065/Isioma_project/work/houseBD_wyzgqi.jpg',
  houseBE : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455066/Isioma_project/work/houseBE_zf6dbk.jpg',
  gen5  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455058/Isioma_project/work/gen5_nbpnrj.jpg',
  houseBF : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455066/Isioma_project/work/houseBF_wijitm.jpg',
  houseC : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455067/Isioma_project/work/houseC_jxwgfo.jpg',
  houseC1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455067/Isioma_project/work/houseC1_wsowei.jpg',
  houseC2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455068/Isioma_project/work/houseC2_dscsyu.jpg',
  houseD : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455068/Isioma_project/work/houseD_fziorn.jpg',
  houseD1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455068/Isioma_project/work/houseD1_iczn9y.jpg',
  houseH : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseH_lanhtc.webp',
  houseG : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseG_tywgby.jpg',
  houseH1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseH1_ci5owb.jpg',
  houseF : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseF_r8csun.jpg',
  houseG1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseG1_g8veck.jpg',
  gen1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gen1_gfa26k.jpg',
  gen2  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455057/Isioma_project/work/gen2_qkmzyi.jpg',
  gen3  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455057/Isioma_project/work/gen3_elcpef.jpg',
  gen4  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455057/Isioma_project/work/gen4_htnzjw.jpg',
  houseG2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455226/Isioma_project/work/houseG2_vljxkl.jpg',
  houseD3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseD3_avr0ud.jpg',
  houseE1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseE1_qhtlyt.jpg',
  houseD2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseD2_ndwecl.jpg',
  houseE : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseE_qegohg.jpg',
  houseI : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseI_lb7ezj.jpg',
  houseI1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseI1_aojtmf.jpg',
  houseI2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455227/Isioma_project/work/houseI2_pjzh6k.jpg',
  houseK : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455228/Isioma_project/work/houseK_ijttxx.jpg',
  houseK1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455228/Isioma_project/work/houseK1_zbsl7y.jpg',
  houseM : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455228/Isioma_project/work/houseM_qhkkiy.jpg',
  houseL : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455228/Isioma_project/work/houseL_vfusqd.jpg',
  houseN : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455228/Isioma_project/work/houseN_ok8b99.jpg',
  houseN1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455229/Isioma_project/work/houseN1_lhbfd9.jpg',
  houseO : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455229/Isioma_project/work/houseO_aws8ne.jpg',
  houseO1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455230/Isioma_project/work/houseO1_cumpkg.jpg',
  houseO2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455230/Isioma_project/work/houseO2_ywvdmb.jpg',
  gallery1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455019/Isioma_project/work/gallery1_wvvmxy.jpg',
  gallery2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697472310/Isioma_project/work/gallery2_hpl7kh.jpg',
  gallery3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455020/Isioma_project/work/gallery3_aaipms.webp',
  gallery4 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455022/Isioma_project/work/gallery4_dr0v0n.jpg',
  gallery5 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455040/Isioma_project/work/gallery5_wyvmao.jpg',
  gallery6 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455055/Isioma_project/work/gallery6_qfj01l.webp',
  gallery7 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery7_amfdgd.jpg',
  gallery8A : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery8A_r0h4hu.jpg',
  gallery8B : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery8B_twn97e.jpg',
  gallery8 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery8_oird3a.jpg',
  gallery9 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery9_qbte7j.jpg',
  gallery9A : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery9A_at2wqv.jpg',
  gallery9B : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455056/Isioma_project/work/gallery9B_x2h7ed.jpg',
  houseP : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455231/Isioma_project/work/houseP_sav6ak.png',
  houseP1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455231/Isioma_project/work/houseP1_mvplhv.jpg',
  houseQ : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455231/Isioma_project/work/houseQ_dam87g.jpg',
  houseR : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455231/Isioma_project/work/houseR_j7la7e.jpg',
  houseS : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455232/Isioma_project/work/houseS_jah9ux.jpg',
  houseS2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455232/Isioma_project/work/houseS2_uyeecf.jpg',
  houseS3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455232/Isioma_project/work/houseS3_cz4mn5.jpg',
  houseS1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455232/Isioma_project/work/houseS1_ncrbwt.jpg',
  houseV2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455233/Isioma_project/work/houseV2_jlhned.jpg',
  houseV : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455233/Isioma_project/work/houseV_tlo8fy.jpg',
  houseV3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455233/Isioma_project/work/houseV3_quus8r.jpg',
  houseV1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455233/Isioma_project/work/houseV1_mpkgbv.jpg',
  houseW : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455234/Isioma_project/work/houseW_ckonsa.jpg',
  houseW1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455234/Isioma_project/work/houseW1_uoi856.jpg',
  houseW2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455234/Isioma_project/work/houseW2_fer5aq.jpg',
  houseW3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455235/Isioma_project/work/houseW3_vadadr.jpg',
  houseX : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455235/Isioma_project/work/houseX_cfyuwm.jpg',
  houseX1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455235/Isioma_project/work/houseX1_xhklfe.webp',
  houseX3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455236/Isioma_project/work/houseX3_emspz6.jpg',
  houseX2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455236/Isioma_project/work/houseX2_nmvpxb.jpg',
  houseY : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455236/Isioma_project/work/houseY_dxuxkv.jpg',
  houseY1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455236/Isioma_project/work/houseY1_yawcvm.jpg',
  houseZ : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455237/Isioma_project/work/houseZ_vbwckn.jpg',
  houseZ1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455237/Isioma_project/work/houseZ1_bju0il.jpg',
  houseZ2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455237/Isioma_project/work/houseZ2_naf1sj.jpg',
  houseZ3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455237/Isioma_project/work/houseZ3_crwaz0.jpg',
  twitter : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455239/Isioma_project/work/twitter_njn3rw.png',
  instagram : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455238/Isioma_project/work/instagram_gt63ic.png',
  linkedin : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455238/Isioma_project/work/linkedin_zxht6a.png',
  star  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455239/Isioma_project/work/star_wb4dvu.png',
  wow  : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
  discount : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455019/Isioma_project/work/discount_cft3zw.png',
  discant : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455019/Isioma_project/work/discant_xa5344.png',
  cancels : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455020/Isioma_project/work/cancels_ydqs2v.png',
  video   : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455242/Isioma_project/work/video_sindks.png',
  welcome : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697475097/Isioma_project/work/welcome_eby8li.jpg',
  sent : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697624602/Isioma_project/work/Group_211_wolujt.png',
  johnson : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787578/Isioma_project/work/johnson_en6qs0.jpg',
  john : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787487/Isioma_project/work/john_rn44vd.jpg',
  linda : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787575/Isioma_project/work/linda_qlc87j.webp',
  chiamaka : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787481/Isioma_project/work/chiamaka_sylehq.jpg',
  couples : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787474/Isioma_project/work/couples_xbcorh.webp',
  michael : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697787575/Isioma_project/work/michael_zhsyk3.jpg',
  blog1 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791300/Isioma_project/work/blog1_xwqmkh.webp',
  blog2 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791302/Isioma_project/work/blog2_sktg0n.jpg',
  blog3 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791364/Isioma_project/work/blog3_rvhqvm.jpg',
  blog4 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791367/Isioma_project/work/blog4_q7hzmx.png',
  blog5: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791363/Isioma_project/work/blog5_kpnz4o.jpg',
  blog6 : 'https://res.cloudinary.com/dneejvhch/image/upload/v1697791363/Isioma_project/work/blog6_hpndp7.jpg',
}


const Houses = [
  {
    title: "Property 1",
    price: "NGN 80,000,000",
    location: "Alimosho, Lagos",
    image: picture.gallery1,
    description:"5 bedroom Fully duplex Installed . Land Size 1200Sam, C of O guaranteed ",
    film: picture.gallery1,
  photos: [picture.gallery1, picture.houseE1, picture.houseD, picture.houseO],
  },
  {
    title: "Property 2",
    price: "NGN 250,000,000",
    location: "Garki, Abuja",
    image: picture.gallery2,
    description:"5 bedroom Fully duplex with BQ Installed solar light. enough parking space, C of O guaranteed ",
    film: picture.gallery2,
    photos: [picture.gallery2, picture.houseZ1, picture.houseI2, picture.houseX],
  },
  {
    title: "Property 3",
    price: "NGN 20,000,000",
    location: "Shomolu, Lagos",
    image: picture.gallery3,
    description:"3 bedroom Fully Bungalow fully fenced. Land Size 2 plots, C of O guaranteed ",
    film: picture.gallery3,
    photos: [picture.gallery3, picture.houseN1, picture.houseS, picture.houseG1],
  },
  {
    title: "Property 4",
    price: "NGN 25,000,000",
    location: "Surulere, Lagos",
    image: picture.gallery4,
    description:"4 bedroom Fully Bungalow fully fenced. Land Size 2 plots, C of O guaranteed ",
    film: picture.gallery4,
    photos: [picture.gallery4, picture.houseO1, picture.houseC2, picture.houseE1],
  },
  {
    title: "Property 5",
    price: "NGN 350,000,000",
    location: "Maitama, Abuja",
    image: picture.gallery5,
    description:"8 bedroom, 2 sitting rooms Mansion with 2 BQ rooms Installed solar light. Land Size 1500Sam, C of O guaranteed ",
    film: picture.gallery5,
    photos: [picture.gallery5, picture.houseY1, picture.houseQ, picture.houseH1],
  },
  {
    title: "Property 6",
    price: "NGN 45,000,000",
    location: "Lekki-Phase-1, Lagos",
    image: picture.gallery6,
    description:"5 bedroom Fully duplex with  solar light. Land Size 3 plots, C of O guaranteed ",
    film: picture.gallery6,
    photos: [picture.gallery6, picture.houseP1, picture.houseBA, picture.houseA1],
  },
];

const Lands = [
  {
    title: "Property 7",
    price: "NGN 2,000,000,000",
    location: "Badagry, Lagos",
    image: picture.home,
    description:"Open Land facing the road fully cleared. Land Size 12 Acres, C of O guaranteed ",
    film: picture.home,
    photos: [picture.home, picture.home, picture.home, picture.home],
  },
  {
    title: "Property 8",
    price: "NGN 150,000,000",
    location: "Festac, Lagos",
    image: picture.gallery7,
    description:"5 bedroom Fully duplex with BQ Installed solar light. Land Size 1200Sam, C of O guaranteed ",
    film: picture.gallery7,
    photos: [picture.gallery7, picture.houseA, picture.houseI2, picture.gen5],
  },
  {
    title: "Property 9",
    price: "NGN 15,000,000",
    location: "Port-hacourt",
    image: picture.gallery8,
    description:"5 bedroom Fully Bungalow under construction but fully roofed. Land Size 2 and half plots, Complete papers ",
    film: picture.gallery8,
    photos: [picture.gallery8, picture.gallery8A, picture.gallery8B, picture.gen3],
  },
  {
    title: "Property 10",
    price: "NGN 35,000,000",
    location: "Ugbowo, Benin-city Benin",
    image: picture.gallery9,
    description:"5 bedroom m Fully Bungalow. large compound with enough parking space. Land Size 3 Plots, C of O guaranteed ",
    film: picture.gallery9,
    photos: [picture.gallery9, picture.gallery9A, picture.gallery9B, picture.houseS],
  }
];


const testimonials = [
  {
    name: "Johnson Okafor",
    title: "Surgeon",
    text:   "Working with CCHomes was a game-changer for my projects. Their attention to detail and commitment to finding the perfect location exceeded my expectations."
    ,
    image: picture.johnson,
  },
  {
    name: " John Faleke",
    title: "Real Estate Developer",
    text: "I couldn't be happier with my investment property from CCHomes. The team's expertise in the market helped me make an informed decision. Their professionalism made the process smooth.",
    image: picture.john,
  },
  {
    name: "David and Michelle Okechukwu",
    title: "Small Business Owners",
    text:  "We are beyond thrilled with our new business location, thanks to CCHomes. Their team understood our unique business needs and found us a commercial space that perfectly suits our requirements.",
    image: picture.couples,
  },
  {
    name: " Linda Ikpama 4",
    title:  "Interior Designer",
    text: "CCHomes provided exceptional service from start to finish. Their knowledge of the local real estate market made my home buying experience enjoyable. I'm grateful for their assistance.",
    image: picture.linda,
  },
  {
    name: " Michael Ojo",
    title: "Entrepreneur",
    text:  "Finding my dream home was a breeze with CCHomes. They listened to my requirements and showed me properties that matched my vision perfectly. I am now living in a house that feels tailor-made for me.",
    image: picture.michael,
  },
  {
    name:  "Chiamaka Godwin",
    title: "Architect",
    text: "As an architect, I have a keen eye for design and quality. CCHomes not only met but exceeded my standards. The property they helped me find is not only beautiful but also structurally sound.",
    image: picture.chiamaka,
  },
];

export const Notification = [
  {
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1698058939/Design_Portfolio/app1splashscreen_kz1sij.png',
    title: 'Check out these new Products in your School',
  },

  {
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676466/Campusbuy/105030016_MTEyNS0xNTAwLTdhOTUzNDZkYTA_kgc4ov.webp',
    title: 'Check out these new Apartments in your School',
  },
]
export const Message = [
  // {
  //   image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1698058939/Design_Portfolio/app1splashscreen_kz1sij.png',
  //   title: 'Hi, I a interested in your 250kg Refridgerator',
  //   name: 'Susan Mayer'
  // },

  // {
  //   image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676466/Campusbuy/105030016_MTEyNS0xNTAwLTdhOTUzNDZkYTA_kgc4ov.webp',
  //   title: 'Hello, what is the last price for your iphone8',
  //   name: 'Gabriella Solis'
  // },
]
export const Callback = [
  {
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1698058939/Design_Portfolio/app1splashscreen_kz1sij.png',
    name: 'Martha Huber',
    Phone: '080987654321',
  },

  {
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676466/Campusbuy/105030016_MTEyNS0xNTAwLTdhOTUzNDZkYTA_kgc4ov.webp',
    name: 'Bree Van de kamp',
    Phone: '070453728913',
  },
]


export const Card = [


  {
    _id: 'ghbhg66t88',
    title: 'XIAOMI Redmi',
    price: "55,000",
    brand: 'XIAOMI',
    Category: 'Android Phones',
    category: 'Vehicles',
    color: 'Black',
    description: 'XIAOMI Redmi 12C 6.71" 3GB RAM/64GB ROM Android 12 - Graphite Grey',
    location: 'Unilag Main Gate',
    stock: 10,
    person: 'store',
    condition: 'New',
    age: '',
    fault: 'None',
    posted: '1 day ago',
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1698058939/Design_Portfolio/app1splashscreen_kz1sij.png',

    photos:[
       {
        image_1: 'https://res.cloudinary.com/dneejvhch/image/upload/v1698058939/Design_Portfolio/app1splashscreen_kz1sij.png',
       image_2: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676455/Campusbuy/1_g9yf9o.jpg',
       image_3: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676455/Campusbuy/1_1_fjtmzn.jpg'
       }
  ],
    details: 'Brand new phone with 1 year warranty',
    seller: 'Solomon Grandy',
    sellerLocation: 'Uniport Hostel 1',
    sellerImage: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
    phone_number_1: '0906472524362',
    phone_number_2: '0917587654443',
    amountSold: '15',
},

{
    _id: '09878ygjkk',
    title: 'IPhone XS',
    price: "195,000",
    brand: 'Apple',
    category: 'Vehicles',
    color: 'Gold',
    description: 'Apple iPhone XS 64 GB Black',
    location: 'Lasu Auditorium',
    stock: 1,
    person: 'individual',
    condition: 'Used',
    age: '1 Year',
    fault: 'None',
    posted: '2 hours ago',
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676466/Campusbuy/105030016_MTEyNS0xNTAwLTdhOTUzNDZkYTA_kgc4ov.webp',

    photos:[
      {
        image_1: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676466/Campusbuy/105030016_MTEyNS0xNTAwLTdhOTUzNDZkYTA_kgc4ov.webp',
      image_2: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676471/Campusbuy/105030020_MTEyNS0xNTAwLTg5M2VhYWFhZTg_gj9utg.webp',
      image_3: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701424576/Campusbuy/137653049_MTUwMC0yMDAwLWU3ODRiYjcwYzI_ukbeun.webp'
      }
    ],
    details: 'Fairly used phone with 6 months warranty',
    seller: 'Johnbull Udegbue',
    sellerLocation: 'Uniben Main gate',
    sellerImage: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
    phone_number_1: '07075546667321',
    phone_number_2: '0700045657733',
    amountSold: '3',
},

{
    _id: 'dddddede22',
    title: 'Toshiba Satellite X-500',
    price: "225,000",
    brand: 'Toshiba',
    category: 'Vehicles',
    color: 'Asphalt Black',
    description: 'Toshiba Satellite X-500 15.6" 4GB RAM/500GB HDD Intel Core i7 - Black',
    location: 'YabaTech Main Hostel',
    stock: 2,
    person: 'individual',
    condition: 'Used',
    age: '6 months',
    fault: 'None',
    posted: '2 weeks ago',
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701426246/Campusbuy/lenovo-laptops-thinkbook-16-gen-4-intel-hero_tngndc.webp',

    photos:[
      {
        image_1: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701426246/Campusbuy/lenovo-laptops-thinkbook-16-gen-4-intel-hero_tngndc.webp',
    image_2: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676456/Campusbuy/44303277_20200504-173441_1_1500x1125_judbbl.webp',
    image_3: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701676455/Campusbuy/44303267_20200504-173416_1_1500x1125_jamstg.webp'
      }
    ],
    details: 'Healthy Toshiba laptop with 6 months warranty',
    seller: 'Humpty Dumpty',
    sellerLocation: 'Lasu Faculty of Law',
    sellerImage: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
    phone_number_1: '0806654352113',
    phone_number_2: '0807774335219',
    amountSold: '10',
},

{
    _id: 'ddfffede22',
    title: 'Elepaq X3kv 500 Generator',
    price: "260,000",
    brand: 'Elepaq',
    category: 'Vehicles',
    color: 'Crimson Red',
    description: 'Maxi Portable Elepaq X3kv Key Start Generator (4.8kva)',
    location: 'Uniport  Anglican Chapel Auditorium',
    stock: 1,
    person: 'individual',
    condition: 'Used',
    age: '8 months',
    fault: 'None',
    posted: '2 days ago',
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686120/Campusbuy/127026138_MTUwMC0xNTAwLTlhNjcyMDQxNjctMQ_voap36.webp',

    photos:[
      {
        image_1: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686120/Campusbuy/127026138_MTUwMC0xNTAwLTlhNjcyMDQxNjctMQ_voap36.webp',
    image_2: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686120/Campusbuy/117743820_ODEwLTEwODAtNDZkMmU5NmRjNw_qis1xp.webp',
    image_3: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701424576/Campusbuy/80472425_MTM2NS0xNTAwLWNkNmMxMGRiZWUtMQ_jy1xxw.webp'
      }
    ],
    details: 'Belgium used Elepaq Generator with solid engine and 6 months warranty',
    seller: 'Lord Farquard',
    sellerLocation: 'Bensu Hall 4',
    sellerImage: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
    phone_number_1: '0712347776566',
    phone_number_2: '071235512223',
    amountSold: '29',
},

{
    _id: 'ddfffese11',
    title: 'Hisense Single Door Refridgerator RS20S',
    price: "240,000",
    brand: 'Hisense',
    category: 'Vehicles',
    color: 'Silver',
    description: 'Modern Hisense `150 litres Single Door Refridgerator RS20S',
    location: 'Auchi Ploytechnic  Anglican Chapel Auditorium',
    stock: 1,
    person: 'individual',
    condition: 'New',
    age: '',
    fault: 'None',
    posted: '3 weeks ago',
    image: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686384/Campusbuy/118707172_MTEyNS0xNTAwLTVjYmJkNDk0MGM_nio3ii.webp',

    photos:[
      {
        image_1: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686384/Campusbuy/118707172_MTEyNS0xNTAwLTVjYmJkNDk0MGM_nio3ii.webp',
        image_2: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686384/Campusbuy/118707032_NzIxLTEyODAtOGUwN2VhOWNjMw_cvis7e.webp',
        image_3: 'https://res.cloudinary.com/dneejvhch/image/upload/v1701686308/Campusbuy/75882006_ODA4LTEwODAtMDczOWNkYmI5Ny0z_b7gwis.webp'
      }
    ],
    details: 'Brand New  Hisesnse 150 litres Freezer with 8 months warranty',
    seller: 'Snow White',
    sellerLocation: 'Yabatech Auditorium',
    sellerImage: 'https://res.cloudinary.com/dneejvhch/image/upload/v1697455241/Isioma_project/work/wow_s7fgmt.png',
    phone_number_1: '0814441213490',
    phone_number_2: '0812228765890',
    amountSold: '4',
},




]
const Feeds = [
  {
    date: "10-Mar-2022",
    title: "Navigating the Real Estate Market: Tips for First-Time Homebuyers",
    description:
      "In this blog post, we can explore valuable tips and insights tailored specifically for individuals stepping into the real estate market for the first time.",
    image: picture.blog1,
  },
  {
    date: "25-Jan-2023",
    title: "Interior Design Trends: Elevate Your Home’s Aesthetics",
    description: "This blog can focus on the latest interior design trends in the real estate market.",
    image: picture.blog2,
  },
  {
    date: "11-Mar-2023",
    title: "The Future of Real Estate: Embracing Smart Home Technology",
    description: "Discuss the impact of technology on the real estate industry, highlighting smart home devices, home automation, and how these advancements are changing the way we live.",
    image: picture.blog3,
  },
  {
    date: "18-April-2023",
    title: "Investing in Real Estate: Strategies for Building Wealth",
    description: "Explore different investment strategies within the real estate market, such as rental properties, commercial real estate, and real estate investment trusts (REITs).",
    image: picture.blog4,
  },
  {
    date: "11-Jun-2023",
    title: "Sustainable Living: Eco-Friendly Homes and Green Real Estate",
    description: "Focus on the growing trend of eco-friendly and sustainable homes. Discuss the importance of green features, energy efficiency, and sustainable building materials.",
    image: picture.blog5,
  },
  {
    date: "20-Sept-2023",
    title:  "Selling Your Home: Effective Staging Tips to Attract Buyers",
    description: "Offer practical advice on staging homes for sale, including decluttering, enhancing curb appeal, and creating inviting interiors.",
    image: picture.blog6,
  },
];

export default {picture, Houses, Lands, Card, testimonials, Feeds};





